// Calendar days travel as UTC days: a subscription's last day ends at 23:59:59.999 UTC, renewals and
// scheduled changes start at 00:00 UTC, and the date inputs speak ISO days. These helpers keep every
// form and label on that one calendar, wherever the viewer is.

// An ISO day (`YYYY-MM-DD`) for a date input, in UTC.
export const toDateInput = (date: Date | string | number): string => new Date(date).toISOString().split('T')[0];

export const todayUtc = (): string => toDateInput(new Date());

export const tomorrowUtc = (): string => {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() + 1);
  return toDateInput(date);
};

// The day a change is in effect. A downgrade's moment is the last instant of the term (23:59:59.999), so the
// day after; an upgrade's or a renewal's is midnight, which the millisecond leaves on the same day.
export const dayAfterTermEnd = (date: Date | string | number): Date => new Date(new Date(date).getTime() + 1);
